export default __webpack_public_path__ + "static/media/logoWhite.99fa62d8.svg";